import VersionHistory from './VersionHistory';

export default VersionHistory;
